import { render } from "./serviceNotice.vue?vue&type=template&id=4fcb543e&scoped=true"
const script = {}

import "./serviceNotice.vue?vue&type=style&index=0&id=4fcb543e&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fcb543e"]])

export default __exports__